const data = {
    flights: document.querySelector('.proflights .data input[name="flights"]') as HTMLInputElement,
};

export { data };
